import React, { JSX } from 'react';
import { FormattedMessage } from 'react-intl';

import { useStyles } from './benefits-list.styles';
import { BenefitsListProps } from './benefits-list.models';

export const BenefitsList = ({ items }: BenefitsListProps): JSX.Element => {
  const classes = useStyles();

  const handleExpnded = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const target = event?.target as HTMLButtonElement;
    const id = target?.getAttribute('aria-controls') as string;
    target?.classList.toggle('expanded');
    const expanded = target?.getAttribute('aria-expanded');
    target?.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true');

    const panel = document.getElementById(id);
    panel?.classList.toggle('expanded');
  };

  return (
    <ul
      className={classes.root}
      data-testid="benefits-list"
    >
      {
        items?.map((item, index) => (
          <li key={index} className={classes.listItem}>
            <button
              aria-expanded="false"
              aria-controls={`panel-${index}`}
              onClick={(e) => handleExpnded(e)}
              className={classes.button}
            >
              <FormattedMessage id={item.title} />
            </button>
            <div className={classes.panel} id={`panel-${index}`}><FormattedMessage id={item.content} /></div>
          </li>
        ))
      }
    </ul>
  );
};
